<div class="multipayment-panel">
    <por-overlay [layout]="'right-panel'" [featureName]="featureName" [isOpen]="isOpen" [trigger]="trigger" (closeOverlayClick)="closeOverlayClick()">
        <div class="multipayment-panel-wrapper mb-2 mt-2">
            @if (appFacadeService.getSelectedInvoicesModels() | async; as invoices) { @if (invoices.length > 0) {
            <div class="selected-invoices">
                <h3>{{ 'SelectedInvoices' | translate }}</h3>
                <table class="table">
                    <thead>
                        <tr>
                            <th>
                                <por-base-button
                                    title="{{ 'Clear All' | translate }}"
                                    [featureName]="'invoice-multipayment-panel-delete-all'"
                                    icon="close"
                                    [iconClass]="'font-18'"
                                    [class]="'transparent'"
                                    (onclick)="removeInvoices(invoices)"></por-base-button>
                            </th>
                            <th>{{ 'invoiceNumber' | translate }}</th>
                            <th>{{ 'Amount Due' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (invoice of invoices; track invoice) {
                        <tr>
                            <td>
                                <por-base-button
                                    (onclick)="removeInvoices(invoice)"
                                    [featureName]="'invoice-multipayment-panel-delete'"
                                    icon="close"
                                    [iconClass]="'font-18'"
                                    [class]="'transparent'"></por-base-button>
                            </td>
                            <td>{{ invoice.InvoiceNumber }}</td>
                            <td class="text-align-right">{{ invoice.AmountDue | formatCurrency }}</td>
                        </tr>
                        }
                    </tbody>
                    <tfoot>
                        <tr>
                            <th colspan="2">{{ 'TotalInvoices' | translate }}</th>
                            <th class="text-align-right">{{ total | formatCurrency }}</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
            } } @if (total < 1) {
            <div class="warnings text-align-center">
                <p>{{ 'PayMinimumAmountDueToProcessPayment1' | translate }} {{ '1' | formatCurrency }} {{ 'PayMinimumAmountDueToProcessPayment2' | translate }}</p>
            </div>
            } @if (appFacadeService.isMaxInvoiceSelected() | async) {
            <div class="warnings text-align-center">
                <p>{{ 'MaximumInvoicesExceeded' | translate : { max: maxInvoicesAllowed, provided: selectedInvoice } }}</p>
            </div>
            }
            <div class="justify-content-center mt-2">
                <por-base-button [class]="'btn-primary'" [theme]="'primary'" [featureName]="'invoice-multipayment-panel-continue'" [disabled]="total < 1" (click)="onClickContinue()">
                    {{ 'Continue' | translate }}
                </por-base-button>
            </div>
        </div>
    </por-overlay>
</div>
